import * as Yup from "yup";

export const partnerSchema = Yup.object().shape({
  name: Yup.string().required("Partner name is required"),
  partner_type_id: Yup.string().required("Partner type is required"),
  institution_id: Yup.string().required("Institution is required"),
  session_id: Yup.string().required("Year is required"),
});
